import e from "../../utils/classNames.js";
import t from "./ListMenuHeader.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/listMenu/ListMenuGroup.tsx
var i = ({ menuGroup: i, className: a }) => i.navItems.length ? /* @__PURE__ */ r("ul", {
	className: `ListMenuGroup ${a}`,
	children: [/* @__PURE__ */ n(t, { ...i }), i.navItems.map((t) => /* @__PURE__ */ n("li", {
		className: e(t.disabled && "disabled", t.isSubItem && "subitem"),
		children: t.item
	}, t.key))]
}) : null;
//#endregion
export { i as default };

//# sourceMappingURL=ListMenuGroup.js.map